module.exports = __webpack_public_path__ + "asset/image-hero-screenshot-be7c5ed596bc147f.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/hero-screenshot.png
// module id = PeML
// module chunks = 1